import { createFileRoute } from "@tanstack/react-router"
import NewsDetail from "../../../components/News/NewsDetail"

export const Route = createFileRoute("/_layout/news/$newsId")({
  component: NewsDetail,
})
